export default [
  { id: 1, key: 'a', value: 'a', label: 'a'},
  { id: 2, key: 'e', value: 'e', label: 'e'},
  { id: 3, key: 'i', value: 'i', label: 'i'},
  { id: 4, key: 'u', value: 'u', label: 'u'},
  { id: 5, key: 'o', value: 'o', label: 'o'},
  { id: 6, key: 'a:', value: 'aː', label: 'aː'},
  { id: 7, key: 'e:', value: 'eː', label: 'eː'},
  { id: 8, key: 'i:', value: 'iː', label: 'iː'},
  { id: 9, key: 'o:', value: 'oː', label: 'oː'},
  { id: 10, key: 'u:', value: 'uː', label: 'uː'},
  { id: 11, key: 'ai', value: 'ai', label: 'ai'},
  { id: 12, key: 'au', value: 'au', label: 'au'},
  { id: 13, key: 'ea', value: 'ea', label: 'ea'},
  { id: 14, key: 'ei', value: 'ei', label: 'ei'},
  { id: 15, key: 'eu', value: 'eu', label: 'eu'},
  { id: 16, key: 'ia', value: 'ia', label: 'ia'},
  { id: 17, key: 'ie', value: 'ie', label: 'ie'},
  { id: 18, key: 'io', value: 'io', label: 'io'},
  { id: 19, key: 'oa', value: 'oa', label: 'oa'},
  { id: 20, key: 'oi', value: 'oi', label: 'oi'},
  { id: 21, key: 'ou', value: 'ou', label: 'ou'},
]
